import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Button,
  Row,
  Col,
} from 'react-bootstrap';

import './style.css';

const typeLayoutPropType = exact({
  onTypeChange: PropTypes.func.isRequired,
});

export class TypeLayout extends Component {
  render() {
    return (
      <div>
        <Row className="timesheet-submission-processor-form-padding-top">
          <Col md={12} className="app-center-text">
            <h4>Select a submission type. </h4>

            <React.Fragment>
              <Button
                bsStyle="info"
                bsSize="large"
                onClick={() => { return this.props.onTypeChange('timesheet'); }}
              >
                Timesheet
              </Button>
              {' '}
              <Button
                bsStyle="info"
                bsSize="large"
                onClick={() => { return this.props.onTypeChange('ticket'); }}
              >
                Ticket
              </Button>
              {' '}
              <Button
                bsStyle="info"
                bsSize="large"
                onClick={() => { return this.props.onTypeChange('ticket_attachment'); }}
              >
                Ticket Attachment
              </Button>
            </React.Fragment>
          </Col>
        </Row>
      </div>
    );
  }
}

TypeLayout.propTypes = typeLayoutPropType;

export default TypeLayout;
